import {
  ADD_PURCHASE_RETURN_LINE_DETAILS,
  UPDATE_PURCHASE_RETURN_LINE_DETAILS,
  GET_PURCHASE_RETURN_LINE_DETAILS,
  GET_PURCHASE_RETURN_LINE_DETAIL,
  DELETE_PURCHASE_RETURN_LINE_DETAILS,
} from '../types';

const initialState = {
  list: [],
  single: null,
};

const reduce = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PURCHASE_RETURN_LINE_DETAILS:
      return { ...state, list: [...state.list, action.payload] };
    case UPDATE_PURCHASE_RETURN_LINE_DETAILS:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item,
        ),
      };
    case GET_PURCHASE_RETURN_LINE_DETAILS:
      return { ...state, list: action.payload };
    case GET_PURCHASE_RETURN_LINE_DETAIL:
      return { ...state, single: action.payload };
    case DELETE_PURCHASE_RETURN_LINE_DETAILS:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== action.payload.id),
      };
    default:
      return state;
  }
};

export default reduce;
